import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import React, { Component } from 'react'
import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl'
import { connect } from "react-redux"
import {
    Link,
    Redirect
} from 'react-router-dom'
import ConfirmButton from "../../common/button/confirmbutton.component.jsx"
import CustomSelect from '../../common/search-filter/others/customSelect.component.jsx'
import { InventoryStockDocumentDefinitionAction, InventoryStockDocumentDefinitionSelector } from "../../state/inventory"
import {
    CUSTOM_FIELD_EDIT_MESSAGES, CUSTOM_FIELD_TYPE,
    CUSTOM_FIELD_TYPE_MESSAGES, getCustomFieldAcceptedFileExtensionSelectOptions, getCustomFieldAvailableFromDefaultSelectOptions
} from "../../utils/customField"
import MetadataListOfChoiceForm from './metadatalistofchoice.component.jsx'

class CustomFieldDefinitionEditForm extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            id: '',
            name: '',
            fieldType: '',
            metadata: [],
            availableFrom: [],
            acceptedFileType: [],
            loaded: false,
            options: getCustomFieldAvailableFromDefaultSelectOptions(this.props.intl),
            acceptedFileExtensionsOptions: getCustomFieldAcceptedFileExtensionSelectOptions(this.props.intl),
        }

        this.submitDefinition = this.submitDefinition.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.handleDocumentSelectChange = this.handleDocumentSelectChange.bind(this)
        this.deleteDefinition = this.deleteDefinition.bind(this)
        this.handleMetadataChange = this.handleMetadataChange.bind(this)
        this.handleFileExtensionChange = this.handleFileExtensionChange.bind(this)
    }

    componentDidMount() {
        if (AppContext.isInventoryEnabled()) {
            this.props.dispatch(InventoryStockDocumentDefinitionAction.fetchListing())
        }

        const definition = this.props.value
        if (definition && definition.id) {
            this.setState({
                id: definition.id,
                name: definition.attributes.name,
                fieldType: definition.attributes.fieldType,
                availableFrom: definition.attributes.availableFrom,
                metadata: definition.attributes.metadata,
                loaded: true,
                acceptedFileType: definition.attributes.acceptedFileType,
            })
        } else {
            this.setState({loaded: true})
        }
    }

    deleteDefinition(event) {
        const definition = this.props.value
        AppContext.getApiClient().delete('/custom-field-definitions/' + definition.id).then((response) => {
            let formStatus = ''
            if (!response.error) {
                formStatus = <Redirect
                    to={{
                        pathname: '/custom-field-definitions/listing'
                    }}
                />
            }
            this.setState({formStatus: formStatus})
        })

        event.preventDefault()
    }

    saveDefinition() {
        const definition = this.props.value
        if (definition && definition.id) {
            let updates = {}
            const allowedFields = [
                "name",
                "fieldType",
                "metadata",
                "availableFrom",
                "acceptedFileType"
            ]
            for (let i = 0; i < allowedFields.length; i++) {
                let field = allowedFields[i]
                if (definition.attributes[field] !== this.state[field]) {
                    updates[field] = this.state[field]
                }
            }
            updates.metadata = this.state.metadata
            updates.availableFrom = this.state.availableFrom
            return AppContext.getApiClient().patch('/custom-field-definitions/' + definition.id, updates)
        } else {
            return AppContext.getApiClient().post('/custom-field-definitions', {
                "name": this.state.name,
                "fieldType": this.state.fieldType,
                "metadata": this.state.metadata,
                "availableFrom": this.state.availableFrom,
                "acceptedFileType":this.state.acceptedFileType,
            })
        }
    }

    submitDefinition(event) {
        this.saveDefinition().then((response) => {
            let formStatus = ''
            if (!response.error) {
                formStatus = <Redirect
                    to={{
                        pathname: '/custom-field-definitions/listing'
                    }}
                />
            }
            this.setState({formStatus: formStatus})
        })

        event.preventDefault()
    }

    handleFormChange(event) {
        const target = event.target
        const value = target.type === 'checkbox' ? target.checked : target.value
        const name = target.name

        this.setState({
            [name]: value
        })

        if (value == CUSTOM_FIELD_TYPE.FILE) {
            this.setState({
                acceptedFileType : this.state.acceptedFileExtensionsOptions.map(option => option.value)
            })
        }
    }

    handleMetadataChange(value) {
        this.setState({
            metadata: value
        })
    }

    handleDocumentSelectChange(documentId) {
        this.setState({
            availableFrom: documentId
        })
    }

    handleFileExtensionChange(fileType) {
        this.setState({
            acceptedFileType: fileType
        })
    }

    saveDisabled(){
        if (this.state.fieldType == CUSTOM_FIELD_TYPE.FILE && this.state.acceptedFileType?.length == 0) return true
        return false
    }

    render() {
        const availableFromOptions = [
            ...this.state.options,
            ...this.props.inventoryStockDocumentDefinitions.map((definition) => {
                return {
                    value: definition.id,
                    label: definition.name
                }
            })]

        let metadata = ''
        if (this.state.fieldType === 'single-choice') {
            metadata = <div className="row">
                <label className="col-2 col-form-label text-align-right" htmlFor="fieldType">
                    <FormattedMessage
                        id="custom_field_definition.form.edit.list_of_choice_label"
                        defaultMessage="List of choice"
                    />
                </label>
                <div className="col-10">
                    <MetadataListOfChoiceForm onChange={this.handleMetadataChange} value={this.state.metadata}/>
                </div>
            </div>
        }

        return (
            <form onSubmit={this.submitDefinition}>
                <div className="row ui-has-modules">
                    <div className="col-12 ui-module">
                        <div className="form-group row">
                            <label className="col-2 col-form-label text-align-right" htmlFor="name">
                                <FormattedMessage
                                    id="custom_field_definition.form.edit.name_label"
                                    defaultMessage="Name"
                                />
                            </label>
                            <div className="col-10">
                                <input
                                    name="name"
                                    value={this.state.name}
                                    onChange={this.handleFormChange}
                                    id="name"
                                    type="text"
                                    className="form-control"
                                    placeholder={this.props.intl.formatMessage(CUSTOM_FIELD_EDIT_MESSAGES['name_placeholder'])}
                                    required
                                />
                                <small className="form-text text-muted">
                                    <FormattedMessage
                                        id="custom_field_definition.form.edit.name_description"
                                        defaultMessage="This name will be shown on the quote form and details in the project details section"
                                    />
                                </small>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-2 col-form-label text-align-right" htmlFor="name">
                                <FormattedMessage
                                    id="custom_field_definition.form.edit.available_from_label"
                                    defaultMessage="Available from"
                                />
                            </label>
                            <div className="col-10">
                                {this.state.loaded &&
                                    <CustomSelect
                                        multi={true}
                                        value={this.state.availableFrom}
                                        options={availableFromOptions}
                                        onChange={this.handleDocumentSelectChange}
                                    />
                                }
                            </div>
                        </div>
                        {this.state.fieldType == CUSTOM_FIELD_TYPE.FILE && 
                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right" htmlFor="name">
                                    <FormattedMessage
                                        id="custom_field_definition.form.edit.accepted_file_extensions_label"
                                        defaultMessage="Accepted File Types"
                                    />
                                </label>
                                <div className="col-10">
                                    {this.state.loaded &&
                                        <CustomSelect
                                            multi={true}
                                            value={this.state.acceptedFileType}
                                            options={this.state.acceptedFileExtensionsOptions}
                                            onChange={this.handleFileExtensionChange}
                                        />
                                    }
                                    {this.state.loaded && this.state.acceptedFileType?.length == 0 && (
                                        <div className="text-danger">
                                            <FormattedMessage
                                                id="custom_field_definition.form.edit.error.accepted_file_types"
                                                defaultMessage="Please select at least one accepted file type."
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        }
                        <div className="form-group row">
                            <label className="col-2 col-form-label text-align-right" htmlFor="fieldType">
                                <FormattedMessage
                                    id="custom_field_definition.form.edit.field_type_label"
                                    defaultMessage="Field type"
                                />
                            </label>
                            <div className="col-10">
                                <select name="fieldType"
                                        value={this.state.fieldType}
                                        onChange={this.handleFormChange}
                                        id="fieldType"
                                        className="form-control"
                                        disabled={!!this.state.id}
                                >
                                    <option value="">
                                        {this.props.intl.formatMessage(CUSTOM_FIELD_EDIT_MESSAGES['choose-type'])}
                                    </option>
                                    <option value="text">
                                        {this.props.intl.formatMessage(CUSTOM_FIELD_TYPE_MESSAGES[CUSTOM_FIELD_TYPE.TEXT])}
                                    </option>
                                    <option value="multi-line-text">
                                        {this.props.intl.formatMessage(CUSTOM_FIELD_TYPE_MESSAGES[CUSTOM_FIELD_TYPE.MULTI_LINE_TEXT])}
                                    </option>
                                    <option value="date">
                                        {this.props.intl.formatMessage(CUSTOM_FIELD_TYPE_MESSAGES[CUSTOM_FIELD_TYPE.DATE])}
                                    </option>
                                    <option value="single-choice">
                                        {this.props.intl.formatMessage(CUSTOM_FIELD_TYPE_MESSAGES[CUSTOM_FIELD_TYPE.SINGLE_CHOICE])}
                                    </option>
                                    <option value="image">
                                        {this.props.intl.formatMessage(CUSTOM_FIELD_TYPE_MESSAGES[CUSTOM_FIELD_TYPE.IMAGE])}
                                    </option>
                                    <option value="file">
                                        {this.props.intl.formatMessage(CUSTOM_FIELD_TYPE_MESSAGES[CUSTOM_FIELD_TYPE.FILE])}
                                    </option>
                                </select>
                                <small className="form-text text-muted">
                                    <FormattedHTMLMessage
                                        id="custom_field_definition.form.edit.type_text_description"
                                        defaultMessage="<b>Text</b> is a free text field"
                                    />
                                    <br/>
                                    <FormattedHTMLMessage
                                        id="custom_field_definition.form.edit.type_multi_line_text_description"
                                        defaultMessage="<b>Multi line text</b> is a free multi line text field"
                                    />
                                    <br/>
                                    <FormattedHTMLMessage
                                        id="custom_field_definition.form.edit.type_date_description"
                                        defaultMessage="<b>Date</b> is a date calendar selector field"
                                    />
                                    <br/>
                                    <FormattedHTMLMessage
                                        id="custom_field_definition.form.edit.type_single_choice_description"
                                        defaultMessage="<b>List of choice</b> is a single choice from a list field"
                                    />
                                    <br/>
                                    <FormattedHTMLMessage
                                        id="custom_field_definition.form.edit.type_image_description"
                                        defaultMessage="<b>Image</b> is an image dropzone"
                                    />
                                    <br/>
                                    <FormattedHTMLMessage
                                        id="custom_field_definition.form.edit.type_file_description"
                                        defaultMessage="<b>File</b> is a file dropzone"
                                    />
                                </small>

                            </div>
                        </div>
                        {metadata}
                    </div>

                    <div className="col-12">
                        {this.state.formStatus}
                    </div>

                    <div className="col-12 ui-module">
                        <div className="row">
                            <div className="col-6">
                                {this.state.id &&
                                    <ConfirmButton identifier={this.state.name}
                                                   href="#"
                                                   onClick={this.deleteDefinition}
                                                   className="btn btn-danger">
                                        <FormattedMessage
                                            id="custom_field_definition.form.edit.delete_btn"
                                            defaultMessage="Delete custom field"
                                        />
                                    </ConfirmButton>
                                }
                            </div>
                            <div className="col-6 text-align-right">
                                <Link to="/custom-field-definitions/listing" className="btn btn-light">
                                    <FormattedMessage
                                        id="custom_field_definition.form.edit.cancel_btn"
                                        defaultMessage="Cancel"
                                    />
                                </Link>
                                &nbsp;
                                &nbsp;
                                <input type="submit"
                                       value={this.props.intl.formatMessage(CUSTOM_FIELD_EDIT_MESSAGES['save_btn'])}
                                       className="btn btn-primary"
                                       disabled= {this.saveDisabled()}/>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        )
    }
}

const mapState = (state, props) => {
    return {
        ...props,
        inventoryStockDocumentDefinitions: InventoryStockDocumentDefinitionSelector.getListing(state),
    }
}
const mapDispatch = (dispatch) => {
    return {
        dispatch: dispatch
    }
}
export default connect(mapState, mapDispatch)(injectIntl(CustomFieldDefinitionEditForm))




// WEBPACK FOOTER //
// ./src/custom-field/form/edit.component.jsx